import _tmpl from "./card.html";
import { LightningElement, registerDecorators as _registerDecorators, registerComponent as _registerComponent } from "lwc";
import { c as classNames } from "ax/chunk_index";
let Shadow = /*#__PURE__*/function (Shadow) {
  Shadow["Default"] = "default";
  Shadow["Elevation1"] = "elevation-1";
  Shadow["Elevation2"] = "elevation-2";
  Shadow["Elevation3"] = "elevation-3";
  Shadow["Elevation4"] = "elevation-4";
  return Shadow;
}({});
let Padding = /*#__PURE__*/function (Padding) {
  Padding["None"] = "none";
  Padding["Small"] = "small";
  Padding["Medium"] = "medium";
  Padding["Large"] = "large";
  return Padding;
}({});
class Card extends LightningElement {
  constructor(...args) {
    super(...args);
    this.padding = Padding.None;
    this.shadow = Shadow.Default;
    this.border = false;
    this.elementHeight = "";
    this.elementWidth = "";
  }
  get classes() {
    return classNames("element", {
      [`styling-padding-${this.padding}`]: this.padding !== Padding.None && Object.values(Padding).includes(this.padding),
      [`styling-shadow-${this.shadow}`]: this.shadow !== Shadow.Default && Object.values(Shadow).includes(this.shadow),
      [`styling-border`]: this.border === "true"
    });
  }
  get width() {
    return this.elementWidth;
  }
  set width(value) {
    this.template.host.style.setProperty("--axds-ovr-card-width", value);
    this.elementWidth = value;
  }
  get height() {
    return this.elementHeight;
  }
  set height(value) {
    this.template.host.style.setProperty("--axds-ovr-card-height", value);
    this.elementHeight = value;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Card, {
  publicProps: {
    padding: {
      config: 0
    },
    shadow: {
      config: 0
    },
    border: {
      config: 0
    },
    width: {
      config: 3
    },
    height: {
      config: 3
    }
  },
  fields: ["elementHeight", "elementWidth"]
});
const __lwc_component_class_internal = _registerComponent(Card, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;